import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInAdmin } from "../../features/adminAuth/adminAuthStorage";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.email || !formData.password) {
      setError("Email and password are required.");
      return;
    }

    setSubmitting(true);
    const result = await signInAdmin({ email: formData.email, password: formData.password });
    if (!result.ok) {
      setError(result.message);
      setSubmitting(false);
      return;
    }

    navigate("/admin/dashboard", { replace: true });
  };

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <h1>Admin Login</h1>
        <p>Access the Verixxon admin console.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="admin@verixxon.com"
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter password"
          />

          <p className="auth-inline-link-row">
            <Link to="/admin/forgot-password">Forgot password?</Link>
          </p>

          {error ? <p className="auth-error">{error}</p> : null}

          <button type="submit" disabled={submitting}>{submitting ? "Signing in..." : "Sign in"}</button>
        </form>

        <p className="auth-switch">
          No admin account? <Link to="/admin/register">Create one</Link>
        </p>
      </section>
    </main>
  );
};

export default AdminLoginPage;
